export default __webpack_public_path__ + "static/media/scrollDown.d431fbbf.svg";